function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import styles from './PartnerApplication.pcss';
var _React_PureComponent;
class PartnerApplication extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { appName, companyName } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.application,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.application__details,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: styles.application__name,
                        children: appName
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.application__company_name,
                        children: companyName
                    })
                ]
            })
        });
    }
}
_define_property(PartnerApplication, "propTypes", {
    // Explicit props
    // logoUri    : PropTypes.string,
    appName: PropTypes.string,
    companyName: PropTypes.string
});
export default withStyles(styles)(PartnerApplication);
